import React, { useEffect } from "react";
import BackgroundImage from "../assets/images/social/social-responsibility.jpg";
import Image1 from "../assets/images/social/school-girl.jpg";
import Image2 from "../assets/images/social/school-boy.jpg";
import Layout from '../components/layout';
import Breadcrumbs from '../components/breadcrumbs';

const Social = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const impactStats = [
        { number: "5%", label: "of the profit from every purchase goes to education", icon: "📊" },
        { number: "$50", label: "sponsors one child for a full year", icon: "🎓" },
        { number: "100%", label: "direct impact - no overhead", icon: "❤️" }
    ];

    return (
        <div>
            <Layout>
                {/* Title Section */}
                <section
                    className="bg-img1 txt-center p-lr-15 p-tb-92"
                    style={{ backgroundImage: `url(${BackgroundImage})` }}
                >
                    <h2 className="ltext-105 cl0 txt-center">Social Responsibility</h2>
                </section>

                <div className="container">
                    <Breadcrumbs />
                </div>

                {/* Impact Hero */}
                <section className="bg0 p-t-40 p-b-40">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 txt-center">
                                <h3 className="ltext-103 cl2 p-b-16">Every Purchase Creates Impact</h3>
                                <p className="stext-113 cl6 p-b-26">
                                    When you choose Molu, you're not just buying a product – you're changing a child's life.
                                </p>
                                
                                {/* Impact Stat Highlight */}
                                <div className="bg-light p-t-30 p-b-30 p-lr-30 m-t-30 m-b-30" 
                                     style={{ 
                                         backgroundColor: '#f2e8df', 
                                         borderRadius: '15px',
                                         border: '2px solid #b98b82'
                                     }}>
                                    <h4 className="mtext-111" style={{ color: '#001f3f' }}>
                                        $75 = One Day of Education
                                    </h4>
                                    <p className="stext-113" style={{ color: '#5c4033', marginBottom: 0 }}>
                                        With every $75 purchase, you provide one full day of school for a child in need
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Content Section */}
                <section className="full-page-section bg0 p-t-40 p-b-120">
                    <div className="container">
                        
                        {/* Our Story Section */}
                        <div className="row p-b-148">
                            <div className="col-md-7 col-lg-8">
                                <div className="p-t-7 p-r-85 p-r-15-lg p-r-0-md">
                                    <h3 className="mtext-111 cl2 p-b-16">Our Story</h3>
                                    <p className="stext-113 cl6 p-b-26">
                                        Our founder's journey to impact began on a dusty road in Zanzibar. What started as a chance encounter with a motorcycle taxi driver who was quietly changing his community became our mission.
                                    </p>
                                    <p className="stext-113 cl6 p-b-26">
                                        That driver had discovered what we now know to be true: <strong style={{ color: '#b98b82' }}>$50 can transform a child's entire future.</strong>
                                    </p>
                                    <p className="stext-113 cl6 p-b-26">
                                        While Tanzania offers free schooling, many families can't afford the registration fees, uniforms, and supplies that make attendance possible. For the cost of a nice dinner, we can give a child a full year of education.
                                    </p>
                                </div>
                            </div>
                            <div className="col-11 col-md-5 col-lg-4 m-lr-auto">
                                <div className="how-bor1">
                                    <div className="hov-img0">
                                        <img src={Image1} alt="Our Story" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Statistics Section */}
                        <div className="row p-b-60">
                            <div className="col-12">
                                <h3 className="mtext-111 cl2 p-b-40 txt-center">Your Impact in Numbers</h3>
                                <div className="row">
                                    {impactStats.map((stat, index) => (
                                        <div key={index} className="col-md-4 p-b-30">
                                            <div className="txt-center p-t-30 p-b-30 p-lr-20" 
                                                 style={{ 
                                                     backgroundColor: '#f2e8df', 
                                                     borderRadius: '10px',
                                                     border: '1px solid #b98b82',
                                                     height: '100%'
                                                 }}>
                                                <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>
                                                    {stat.icon}
                                                </div>
                                                <h4 className="mtext-106" style={{ color: '#001f3f', marginBottom: '0.5rem' }}>
                                                    {stat.number}
                                                </h4>
                                                <p className="stext-113" style={{ color: '#5c4033', marginBottom: 0 }}>
                                                    {stat.label}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Our Mission Section */}
                        <div className="row">
                            <div className="order-md-2 col-md-7 col-lg-8 p-b-30">
                                <div className="p-t-7 p-l-85 p-l-15-lg p-l-0-md">
                                    <h3 className="mtext-111 cl2 p-b-16">Your Partnership with Purpose</h3>
                                    <p className="stext-113 cl6 p-b-26">
                                        <strong>5% of the profits from every Molu purchase goes directly to school fees</strong> for children in Tanzania and Ethiopia. No overhead, no administrative costs eaten up by middlemen – just direct impact.
                                    </p>
                                    <p className="stext-113 cl6 p-b-26">
                                        When you buy from Molu, you're joining a community of customers who believe that business should be a force for good. You're not just making a purchase; you're making a statement that quality products and meaningful impact can go hand in hand.
                                    </p>
                                    <div className="bor16 p-l-29 p-b-9 m-t-22" style={{ borderColor: '#b98b82' }}>
                                        <p className="stext-114 cl6 p-r-40 p-b-11">
                                            "Every child we support doesn't just change their own life – they lift up their entire family and community."
                                        </p>
                                        <span className="stext-111" style={{ color: '#b98b82' }}>— Molu Team</span>
                                    </div>
                                </div>
                            </div>
                            <div className="order-md-1 col-11 col-md-5 col-lg-4 m-lr-auto p-b-30">
                                <div className="how-bor2">
                                    <div className="hov-img0">
                                        <img src={Image2} alt="Our Mission" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Why Education Section */}
                        <div className="row p-t-80">
                            <div className="col-12">
                                <h3 className="mtext-111 cl2 p-b-16 txt-center">Why Education Changes Everything</h3>
                                <div className="row justify-content-center">
                                    <div className="col-lg-10">
                                        <p className="stext-113 cl6 p-b-26 txt-center">
                                            In today's rapidly evolving world, education is the great equalizer. While technology creates new opportunities, it also widens the gap between those who have access and those who don't.
                                        </p>
                                        <p className="stext-113 cl6 p-b-26 txt-center">
                                            By supporting education in underserved communities, we're ensuring that talented children get the chance they deserve – regardless of where they're born.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Call to Action */}
                        <div className="row p-t-60">
                            <div className="col-12 txt-center">
                                <div className="p-t-40 p-b-40 p-lr-40" 
                                     style={{ 
                                         backgroundColor: '#001f3f', 
                                         borderRadius: '15px',
                                         color: '#f2e8df'
                                     }}>
                                    <h3 className="mtext-111 p-b-16" style={{ color: '#f2e8df' }}>
                                        Ready to Make an Impact?
                                    </h3>
                                    <p className="stext-113 p-b-30" style={{ color: '#f2e8df' }}>
                                        Every Molu product comes with the promise that your purchase is changing lives – one child, one day, one future at a time.
                                    </p>
                                    <a href="/shop" 
                                       className="flex-c-m stext-101 cl0 size-107 bg-light hov-btn1 p-lr-15 trans-04"
                                       style={{ 
                                           backgroundColor: '#f2e8df', 
                                           color: '#001f3f',
                                           borderRadius: '25px',
                                           textDecoration: 'none',
                                           display: 'inline-block',
                                           padding: '12px 30px'
                                       }}>
                                        Shop with Purpose
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        </div>
    );
};

export default Social;